module.exports = __webpack_public_path__ + "img/register.9e00a37.svg";